import type { ReactNode } from 'react';

import classNames from 'classnames';

interface Props {
  icon: ReactNode;
  mode?: 'dark' | 'light';
  text: string;
}

export const IconPill = ({ text, mode = 'dark', icon }: Props) => (
  <div
    className={classNames(
      'vai-border vai-rounded-full vai-py-[2px] vai-px-3 vai-inline-flex vai-justify-center vai-items-center vai-gap-2',
      {
        'vai-border-zinc-800 vai-bg-zinc-700 vai-text-zinc-50': mode === 'dark',
        'vai-border-zinc-200 vai-bg-zinc-100 vai-text-zinc-900':
          mode === 'light',
      },
    )}
  >
    <p className="vai-font-inter vai-text-xs vai-font-semibold">{text}</p>
    {icon}
  </div>
);
